import React from 'react'
import { useSelector } from 'react-redux'

import { Switch } from 'antd'
import { Dropdown } from 'primereact/dropdown'
import { Toolbar } from 'primereact/toolbar'

import AddNewButton from '../../../../components/CustomButtons/addNewButton'
import ExportButton from '../../../../components/CustomButtons/exportGreenButton'
import GlobalSearchInput from '../../../../components/CustomGlobalSearchInput/globalSearchInput'
import { getMessage } from '../../../../util/IntlMessages'
import { isAdmin } from '../../../../util/profiles'

const Header = ({
  selectedReferencePeriod,
  referencePeriods,
  setSelectedReferencePeriod,
  globalFilterValue,
  onGlobalFilterChange,
  exportCSV,
  exportExcelData,
  history,
  actionsIsActive,
  setActionsIsActive
}) => {
  const currentUser = useSelector((state) => state.auth.auth)
  return (
    <Toolbar
      start={
        <React.Fragment>
          <div>
            <h2>
              <b>Lista de Visitas</b>
            </h2>
            {currentUser && isAdmin() && (
              <p style={{ fontSize: '12px' }}>
                {actionsIsActive ? 'Visitas ativas' : 'Visitas inativas'}
                <Switch
                  style={{ marginLeft: 10 }}
                  checked={actionsIsActive}
                  onChange={() => setActionsIsActive(!actionsIsActive)}
                  className="mr-2"
                  size="small"
                />
              </p>
            )}
          </div>
        </React.Fragment>
      }
      end={
        <div className="container-header-lists">
          <span className="p-float-label">
            <Dropdown
              inputId="dd-city"
              value={selectedReferencePeriod}
              onChange={(e) => setSelectedReferencePeriod(e.value)}
              options={referencePeriods}
              optionLabel="description"
              className="w-full md:w-14rem"
              style={{ position: 'relative', height: '40px', fontSize: '10px' }}
            />
            <label htmlFor="dd-city" style={{ left: 0, position: 'absolute' }}>
              Selecione uma safra
            </label>
          </span>

          <GlobalSearchInput value={globalFilterValue} onChange={onGlobalFilterChange} />

          <div>
            <ExportButton iconType="csv" label={getMessage('label.exportCvs')} onClick={() => exportCSV(false)} />
            <ExportButton iconType="excel" label={getMessage('label.exportXls')} onClick={exportExcelData} />
            <AddNewButton label={getMessage('createAction')} onClick={() => history.push('/actions/create')} />
          </div>
        </div>
      }
    />
  )
}

export default Header
